import React from 'react';

import { useApp } from '../store/AppContext';
import { effJiraKey } from '../utils/jira';
import EpicOption from './EpicOption';
import EpicImportDialog from './jiraEpicsModal/EpicImportDialog';

/* Fenêtre de sélection des epics Jira à importer (file d attente d import). */
export default function JiraEpicsModal() {
  const { advanceEpicQueue, jiraEpicsModal, setJiraEpicsModal, appState } = useApp();
  if (!jiraEpicsModal) return null;
  const { clientId, phaseId, epics, selected } = jiraEpicsModal;
  const jClient = (appState.clients || []).find((c) => c.id === clientId);
  const jPhase = jClient ? (jClient.phases || []).find((ph) => ph.id === phaseId) : null;
  const existingEpics = new Set((jPhase?.briques || []).map((b) => b.jira_epic).filter(Boolean));
  const toggle = (key) =>
    setJiraEpicsModal((m) => {
      const s = new Set(m.selected);
      s.has(key) ? s.delete(key) : s.add(key);
      return { ...m, selected: s };
    });
  return (
    <div className="modal-overlay" onClick={advanceEpicQueue}>
      <EpicImportDialog
        epics={epics}
        existingEpics={existingEpics}
        jClient={jClient}
        jPhase={jPhase}
        selected={selected}
        toggle={toggle}
      />
    </div>
  );
}
